import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  IndexUniqueness_Unique_getInstance3k1wv494ui8l1 as IndexUniqueness_Unique_getInstance,
  IndexSetppgakdbfpe00 as IndexSet,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  $serializer_getInstance33z4kgxgrgb0n as $serializer_getInstance,
  Cents1lsbs5l1tlgw as Cents,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
} from '../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  values1pffia4rorsp7 as values,
  Companion_getInstance1zy63bfjbn01p as Companion_getInstance,
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance_0,
  IDqqik72jjbpsn as ID,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulzrhf9x0v3ec95 as ID__hashCode_impl_f4lulz,
} from './domain.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { YearMonthSerializer_getInstance1mubu03fd28xn as YearMonthSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/YearMonthSerializers.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_0($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.EmployerMonthAggregates.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(EmployerMonthAggregates())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_s1dcib_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_s1dcib_k$(encoder, value instanceof ID_0() ? value.raw_1 : THROW_CCE());
      }
      deserialize_j2au8c_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_0())(this.deserialize_j2au8c_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz_0($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_0()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_0())(other instanceof ID_0() ? other.raw_1 : THROW_CCE()));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.EmployerMonthAggregates.Stats', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('childPlacements', true);
        tmp0_serialDesc.addElement_5pzumi_k$('children', true);
        tmp0_serialDesc.addElement_5pzumi_k$('families', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_v044a7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.childPlacements_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.childPlacements_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.children_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.children_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.families_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.families_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_v044a7_k$(encoder, value instanceof Stats() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = 0;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Stats().new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_Stats_9s0p7z_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_2() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.EmployerMonthAggregates.MoneyBreakdown', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('totalCostOfCare', false);
        tmp0_serialDesc.addElement_5pzumi_k$('employerShare', false);
        tmp0_serialDesc.addElement_5pzumi_k$('employerAdministrationFee', false);
        tmp0_serialDesc.addElement_5pzumi_k$('grantMatch', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_5u6z3f_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance(), new (Cents())(value.totalCostOfCare_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Cents())(value.employerShare_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (Cents())(value.employerAdministrationFee_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance(), new (Cents())(value.grantMatch_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_5u6z3f_k$(encoder, value instanceof MoneyBreakdown() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (Cents())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_8 = $serializer_getInstance();
          var tmp_9 = tmp7_local3;
          var tmp_10 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (Cents())(tmp_9));
          tmp7_local3 = tmp_10 == null ? null : tmp_10.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_11 = $serializer_getInstance();
                var tmp_12 = tmp4_local0;
                var tmp_13 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_11, tmp_12 == null ? null : new (Cents())(tmp_12));
                tmp4_local0 = tmp_13 == null ? null : tmp_13.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp5_local1;
                var tmp_16 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_14, tmp_15 == null ? null : new (Cents())(tmp_15));
                tmp5_local1 = tmp_16 == null ? null : tmp_16.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_17 = $serializer_getInstance();
                var tmp_18 = tmp6_local2;
                var tmp_19 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_17, tmp_18 == null ? null : new (Cents())(tmp_18));
                tmp6_local2 = tmp_19 == null ? null : tmp_19.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_20 = $serializer_getInstance();
                var tmp_21 = tmp7_local3;
                var tmp_22 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_20, tmp_21 == null ? null : new (Cents())(tmp_21));
                tmp7_local3 = tmp_22 == null ? null : tmp_22.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return MoneyBreakdown().new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_MoneyBreakdown_7mbbtd_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_3() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function EmployerMonthAggregates$Companion$$childSerializers$_anonymous__putnyn() {
  return new (LinkedHashMapSerializer())(createSimpleEnumSerializer('org.thecommunitygroupinc.cares.AgeGroup', values()), $serializer_getInstance_2());
}
function EmployerMonthAggregates$Companion$$childSerializers$_anonymous__putnyn_0() {
  return new (LinkedHashMapSerializer())(Companion_getInstance().serializer_9w0wvi_k$(), $serializer_getInstance_2());
}
var IDClass;
function ID_0() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_0(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_0(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_1});
    IDClass = $;
  }
  return IDClass;
}
var StatsClass;
function Stats() {
  if (StatsClass === VOID) {
    class $ {
      constructor(childPlacements, children, families) {
        childPlacements = childPlacements === VOID ? 0 : childPlacements;
        children = children === VOID ? 0 : children;
        families = families === VOID ? 0 : families;
        this.childPlacements_1 = childPlacements;
        this.children_1 = children;
        this.families_1 = families;
      }
      toString() {
        return 'Stats(childPlacements=' + this.childPlacements_1 + ', children=' + this.children_1 + ', families=' + this.families_1 + ')';
      }
      hashCode() {
        var result = this.childPlacements_1;
        result = imul(result, 31) + this.children_1 | 0;
        result = imul(result, 31) + this.families_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Stats()))
          return false;
        if (!(this.childPlacements_1 === other.childPlacements_1))
          return false;
        if (!(this.children_1 === other.children_1))
          return false;
        if (!(this.families_1 === other.families_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_Stats_9s0p7z_k$(seen0, childPlacements, children, families, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.childPlacements_1 = 0;
        else
          $this.childPlacements_1 = childPlacements;
        if (0 === (seen0 & 2))
          $this.children_1 = 0;
        else
          $this.children_1 = children;
        if (0 === (seen0 & 4))
          $this.families_1 = 0;
        else
          $this.families_1 = families;
        return $this;
      }
    }
    initMetadataForClass($, 'Stats', Stats, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    StatsClass = $;
  }
  return StatsClass;
}
var MoneyBreakdownClass;
function MoneyBreakdown() {
  if (MoneyBreakdownClass === VOID) {
    class $ {
      constructor(totalCostOfCare, employerShare, employerAdministrationFee, grantMatch) {
        this.totalCostOfCare_1 = totalCostOfCare;
        this.employerShare_1 = employerShare;
        this.employerAdministrationFee_1 = employerAdministrationFee;
        this.grantMatch_1 = grantMatch;
      }
      toString() {
        return 'MoneyBreakdown(totalCostOfCare=' + Cents__toString_impl_ko5hxm(this.totalCostOfCare_1) + ', employerShare=' + Cents__toString_impl_ko5hxm(this.employerShare_1) + ', employerAdministrationFee=' + Cents__toString_impl_ko5hxm(this.employerAdministrationFee_1) + ', grantMatch=' + Cents__toString_impl_ko5hxm(this.grantMatch_1) + ')';
      }
      hashCode() {
        var result = Cents__hashCode_impl_slsn8n(this.totalCostOfCare_1);
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.employerShare_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.employerAdministrationFee_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.grantMatch_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MoneyBreakdown()))
          return false;
        if (!(this.totalCostOfCare_1 === other.totalCostOfCare_1))
          return false;
        if (!(this.employerShare_1 === other.employerShare_1))
          return false;
        if (!(this.employerAdministrationFee_1 === other.employerAdministrationFee_1))
          return false;
        if (!(this.grantMatch_1 === other.grantMatch_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_MoneyBreakdown_7mbbtd_k$(seen0, totalCostOfCare, employerShare, employerAdministrationFee, grantMatch, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        $this.totalCostOfCare_1 = totalCostOfCare;
        $this.employerShare_1 = employerShare;
        $this.employerAdministrationFee_1 = employerAdministrationFee;
        $this.grantMatch_1 = grantMatch;
        return $this;
      }
    }
    initMetadataForClass($, 'MoneyBreakdown', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    MoneyBreakdownClass = $;
  }
  return MoneyBreakdownClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, EmployerMonthAggregates$Companion$$childSerializers$_anonymous__putnyn);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, tmp_1, lazy(tmp_2, EmployerMonthAggregates$Companion$$childSerializers$_anonymous__putnyn_0)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.EmployerMonthAggregates', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('month', false);
        tmp0_serialDesc.addElement_5pzumi_k$('breakdown', true);
        tmp0_serialDesc.addElement_5pzumi_k$('total', false);
        tmp0_serialDesc.addElement_5pzumi_k$('byAgeGroup', false);
        tmp0_serialDesc.addElement_5pzumi_k$('byProviderType', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['employer', 'month'], IndexUniqueness_Unique_getInstance()));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_cckrvy_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_1(), new (ID_0())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_0(), new (ID())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, YearMonthSerializer_getInstance(), value.month_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.breakdown_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, $serializer_getInstance_3(), value.breakdown_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_2(), value.total_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.byAgeGroup_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.byProviderType_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_cckrvy_k$(encoder, value instanceof EmployerMonthAggregates() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_1();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_0())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_0();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, YearMonthSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, $serializer_getInstance_2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_1();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_0())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_0();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (ID())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, YearMonthSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, $serializer_getInstance_2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EmployerMonthAggregates().new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_mwg1tg_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_4().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_1(), $serializer_getInstance_0(), YearMonthSerializer_getInstance(), get_nullable($serializer_getInstance_3()), $serializer_getInstance_2(), tmp0_cached[5].get_value_j01efc_k$(), tmp0_cached[6].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_4() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var EmployerMonthAggregatesClass;
function EmployerMonthAggregates() {
  if (EmployerMonthAggregatesClass === VOID) {
    class $ {
      constructor(_id, employer, month, breakdown, total, byAgeGroup, byProviderType) {
        Companion_getInstance_4();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        breakdown = breakdown === VOID ? null : breakdown;
        this._id_1 = _id;
        this.employer_1 = employer;
        this.month_1 = month;
        this.breakdown_1 = breakdown;
        this.total_1 = total;
        this.byAgeGroup_1 = byAgeGroup;
        this.byProviderType_1 = byProviderType;
      }
      get__id_2o62mx_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_0())(this.get__id_2o62mx_k$());
      }
      toString() {
        return 'EmployerMonthAggregates(_id=' + ID__toString_impl_y5caka_0(this._id_1) + ', employer=' + ID__toString_impl_y5caka(this.employer_1) + ', month=' + this.month_1.toString() + ', breakdown=' + toString_0(this.breakdown_1) + ', total=' + this.total_1.toString() + ', byAgeGroup=' + toString(this.byAgeGroup_1) + ', byProviderType=' + toString(this.byProviderType_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_0(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz(this.employer_1) | 0;
        result = imul(result, 31) + this.month_1.hashCode() | 0;
        result = imul(result, 31) + (this.breakdown_1 == null ? 0 : this.breakdown_1.hashCode()) | 0;
        result = imul(result, 31) + this.total_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.byAgeGroup_1) | 0;
        result = imul(result, 31) + hashCode(this.byProviderType_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerMonthAggregates()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!this.month_1.equals(other.month_1))
          return false;
        if (!equals(this.breakdown_1, other.breakdown_1))
          return false;
        if (!this.total_1.equals(other.total_1))
          return false;
        if (!equals(this.byAgeGroup_1, other.byAgeGroup_1))
          return false;
        if (!equals(this.byProviderType_1, other.byProviderType_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_EmployerMonthAggregates_mwg1tg_k$(seen0, _id, employer, month, breakdown, total, byAgeGroup, byProviderType, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(118 === (118 & seen0))) {
          throwMissingFieldException(seen0, 118, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.employer_1 = employer;
        $this.month_1 = month;
        if (0 === (seen0 & 8))
          $this.breakdown_1 = null;
        else
          $this.breakdown_1 = breakdown;
        $this.total_1 = total;
        $this.byAgeGroup_1 = byAgeGroup;
        $this.byProviderType_1 = byProviderType;
        return $this;
      }
    }
    initMetadataForClass($, 'EmployerMonthAggregates', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_4});
    EmployerMonthAggregatesClass = $;
  }
  return EmployerMonthAggregatesClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_getInstance_4 as Companion_getInstance1ymz2mf6vmsl4,
  Companion_instance as Companion_instancenb4qjspelti9,
  Companion_instance_1 as Companion_instance33tvqjkvwv8e1,
  Companion_instance_0 as Companion_instance1ucbvdkx25cw,
  EmployerMonthAggregates as EmployerMonthAggregates15vmzuxkabqjv,
};
//endregion

//# sourceMappingURL=employerAggregations.mjs.map
